// Client-side sort for the job list. The API returns rows by
// createdAt DESC; the shell re-orders so the requested sort key
// drives the views uniformly.
import type {
  JobDto,
  JobPriority,
} from "../../../../../../shared/types/production-schedule";

const PRIORITY_RANK: Record<JobPriority, number> = {
  Urgent: 0,
  High: 1,
  Normal: 2,
  Low: 3,
};

function cmpStr(a: string, b: string): number {
  return a.localeCompare(b);
}

function cmpDate(a: string | null, b: string | null): number {
  const av = a ?? "9999-12-31";
  const bv = b ?? "9999-12-31";
  return av.localeCompare(bv);
}

export function applyClientSort(jobs: JobDto[], sort: string): JobDto[] {
  const copy = jobs.slice();
  switch (sort) {
    case "date":
      copy.sort((a, b) => cmpDate(a.dueDate, b.dueDate));
      break;
    case "startDate":
      copy.sort((a, b) => cmpDate(a.startDate, b.startDate));
      break;
    case "id":
      copy.sort((a, b) => cmpStr(a.jobNumber, b.jobNumber));
      break;
    case "name":
      copy.sort((a, b) => cmpStr(a.name, b.name));
      break;
    case "priority":
    default:
      copy.sort((a, b) => PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority]);
      break;
  }
  return copy;
}
